module.exports = __webpack_public_path__ + "img/utilities-icon.937d5c03.svg";